import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const IconOthers = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 29 28">
      <path
        d="M14.3333 15C14.8856 15 15.3333 14.5523 15.3333 14C15.3333 13.4477 14.8856 13 14.3333 13C13.781 13 13.3333 13.4477 13.3333 14C13.3333 14.5523 13.781 15 14.3333 15Z"
        stroke="#2E434D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 15C21.8856 15 22.3333 14.5523 22.3333 14C22.3333 13.4477 21.8856 13 21.3333 13C20.781 13 20.3333 13.4477 20.3333 14C20.3333 14.5523 20.781 15 21.3333 15Z"
        stroke="#2E434D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33331 15C7.8856 15 8.33331 14.5523 8.33331 14C8.33331 13.4477 7.8856 13 7.33331 13C6.78103 13 6.33331 13.4477 6.33331 14C6.33331 14.5523 6.78103 15 7.33331 15Z"
        stroke="#2E434D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default IconOthers;
